// to share mutation result after refetching
export const getTFARefetchFixedCacheKey = (endpointName: string) =>
  `2fa-${endpointName}`;
